// keep in sync with media.scss
export const SMALL = 360;
export const MEDIUM = 744;
export const LARGE = 1366;
export const MAX_WIDTH = 1920;